// 入会入力の制限時間 30 分
export const TIMEOUT = 300
